import React, {memo, useCallback, useEffect, useMemo, useRef, useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import DivideSparkImg from "../../pages/photobooth/DivideSparkImg";
import {useCollectionData} from "react-firebase-hooks/firestore";
import {ballroomOnlineChatRef} from "../../config/firebaseConfig";
import ChatMessage from "../dirrectMessages/ChatMessage";

const useStyles = makeStyles({
    root: {
        width: '100%',
        zIndex: 5
        // height: props => props.height
    },
    titleDiv: {
        fontSize: '1.1vw',
        padding: '0.5vw 1.2vw'
    },
    titleSpan: {
    },
    divideSpark: {
        height: 10,
        marginTop: -23
    },
    messagesRoot: {
        padding: '0px 1.2vw',
        maxHeight: props => props.chatMaxHeight * (window.innerWidth < 1200 ? 0.55 : 0.67) ,
        height: props => props.chatMaxHeight * (window.innerWidth < 1200 ? 0.55 : 0.67) ,
        overflowY: 'scroll',
        overflowX: 'hidden'
    },
    onlineUsersDiv: {
        fontSize: '1.1vw',
        textAlign: 'left',
        color: 'rgb(189, 159, 111)'
    },
    // message: {
    //     textAlign: props => props. message.align,
    //     marginTop: 10
    // }
})

const OnlineChatPanel = ({height, user, users, onlineUsers, islive}) => {
    const [messages] = useCollectionData(ballroomOnlineChatRef.orderBy('timestamp', 'asc'), {idField: 'id'})
    const [curMessage, setCurMessage] = useState('')
    const [chatMaxHeight, setChatMaxHeight] = React.useState(window.innerWidth * 0.265);
    const dummyOne = useRef(null)

    useEffect(() => {
        if (document.getElementById('video-player')) {
            setChatMaxHeight(document.getElementById('video-player').offsetHeight);
        }
    })

    useEffect(() => {
        dummyOne.current.scrollIntoView({behavior: 'smooth'});
    }, [messages])

    const onMessageChange = useCallback(e => {
        setCurMessage(e.target.value)
    }, [])

    const sendMessage = () => {
        if (!curMessage.trim())
            return

        const message = {
            userId: user.CustID,
            timestamp: Date.now(),
            data: curMessage.trim(),
        };

        return ballroomOnlineChatRef.add(message)
            .then(() => setCurMessage(''));
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault()
            sendMessage();
        }
    };

    const classes = useStyles({height, chatMaxHeight})

    const messagesWithUserFrom = useMemo(() => (user && users && messages) ? messages.map(m => {
        const userFrom = users.find(u => u.CustID === m.userId)
        return {
            ...m,
            userFrom
        }
    }) : null, [user, users, messages])

    return (
      <div className={classes.root + " coverup"} style={{height: '100%'}}>
          <div className={classes.titleDiv}>
              <span className={classes.titleSpan + " pull-left"}>Live Chat</span>
          </div>
          <DivideSparkImg className={classes.divideSpark}/>
          <div className={'custom-scrollbar ' + classes.messagesRoot}>
              <div className={classes.onlineUsersDiv}> {onlineUsers ? onlineUsers.length : '--'} online users</div>

              {messagesWithUserFrom && messagesWithUserFrom.map((message, i) =>
                <ChatMessage key={i} msg={message} user={user} userFrom={message.userFrom}/>
              )}

              <span ref={dummyOne}/>
          </div>
          <DivideSparkImg style={{height: 10}}/>
          {islive ?<div className="chatInput chatInput-min message-input-area-live">
              <div>You:</div>
              <div style={{width: '100%'}}>
                  <input type="text"
                         value={curMessage}
                         onKeyDown={handleKeyDown}
                         onChange={onMessageChange}
                         placeholder="Type your message here"
                         style={{fontSize: '1em'}}
                  />
              </div>
          </div>
          :
            <div className="chatInput chatInput-min message-input-area-conv" style={{margin: '0 12px 0 1.2vw'}}>
                This feature is no longer available
            </div>
          }
      </div>
    )
}

export default memo(OnlineChatPanel);